import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

interface TagProps {
  className?: string;
  dark?: boolean;
  disabled?: boolean;
  active?: boolean;
  onClick: () => void;
}

const StyledTag = styled.button<Pick<TagProps, 'dark' | 'active'>>`
  margin: 0;
  border: solid 1px #d2d6e8;
  padding: 0.3rem 0.5rem;
  color: #7f89a7;
  background: #fff;
  border-radius: 15px;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;

  ${({ dark }) =>
    dark &&
    css`
      background: #515f7f;
      color: #fff;
      border-color: #8093bf;
    `}

  &:hover {
    background: #d2d6e8;
    color: #fff;
    ${({ dark }) =>
      dark &&
      css`
        background: #fff;
        color: #515f7f;
      `}
  }

  ${({ active }) =>
    active &&
    css`
      background: #630e17;
      border-color: #630e17;
      color: #fff;

      &:hover {
        background: #630e17;
        border-color: #630e17;
      }
    `}
`;

// This is how to acheive styling on siblings
const StyledTagSibling = styled(StyledTag)<Pick<TagProps, 'disabled'>>`
  & + & {
    margin-left: 0.5rem;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
    `}
`;

export function Tag({
  children,
  dark,
  disabled = false,
  active,
  onClick,
}: PropsWithChildren<TagProps>) {
  return (
    <StyledTagSibling
      dark={dark}
      active={active}
      onClick={onClick}
      disabled={disabled}
      type='button'
    >
      {children}
    </StyledTagSibling>
  );
}
